<template>
    <section class="awards">
        <div class="awards__container">
            <h2>價值<span class="small">$</span><span>70,000</span>多重好禮</h2>
            <div class="awards__caption" data-aos="fade-up" data-aos-duration="1500">
                <h3>超過50名中獎機會</h3>
                <img src="@/assets/images/awards__product01.png" alt="2％水楊酸精華液" loading="lazy" />
            </div>
            <div class="awards__item one" data-aos="fade-up" data-aos-duration="1500">
                <img src="@/assets/images/awards__product02.png" alt="2％水楊酸精華液" loading="lazy" />
                <div class="awards__item__content">
                    <h4>美肌榮耀</h4>
                    <p>2％水楊酸精華液</p>
                    <span>（1年份！118mlx6罐）</span>
                    <div class="awards__item__price">價值＄6,480</div>
                    <span>共3名</span>
                </div>
            </div>
            <div class="awards__list" data-aos="fade-up" data-aos-duration="1500">
                <div v-for="award in awardsList" :key="award.title" class="awards__item">
                    <div class="awards__img">
                        <div class="awards__medal_border">
                            <div class="awards__medal">
                                <span>{{ award.order }}</span>獎
                            </div>
                        </div>
                        <img :src="imgSrc(award.img)" :alt="award.title" loading="lazy" />
                    </div>
                    <div class="dividingLine"></div>
                    <h4> {{ award.title }}</h4>
                    <p>{{ award.productName }}</p>
                    <div class="awards__item__price">{{ award.price }}</div>
                    <span>共{{ award.menber }}名</span>
                </div>
            </div>
            <div class="awards__link">
                <a
                    href="https://www.paulaschoice.com.tw/linebinding-step1.php?source=pixnet"
                    target="_blank"
                    @click="gtagEvent('https://www.paulaschoice.com.tw/linebinding-step1.php?source=pixnet', '按鈕點擊', '免費領取試用')"
                >
                    <LinkBtn title="免費領取試用" />
                </a>
                <a
                    href="https://topic.events.pixnet.net/submit/1028"
                    target="_blank"
                    @click="gtagEvent('https://topic.events.pixnet.net/submit/1028', '按鈕點擊', '回填心得領好禮')"
                >
                    <LinkBtn title="回填心得領好禮" />
                </a>
            </div>
        </div>
    </section>
</template>

<script setup>
import LinkBtn from '@/components/widget/LinkBtn.vue';
import awardsList from '@/assets/data/awardsList.json';
import gtagEvent from '@/assets/js/gtag';
const imgSrc = imgName => require(`@/assets/images/${imgName}`);
</script>

<style lang="scss" scoped>
@import '@/styles/theAwards';
</style>
